import { render, staticRenderFns } from "./PersonalDataConsentForm.vue?vue&type=template&id=762061a4&scoped=true"
import script from "./PersonalDataConsentForm.vue?vue&type=script&lang=js"
export * from "./PersonalDataConsentForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataConsentForm.vue?vue&type=style&index=0&id=762061a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762061a4",
  null
  
)

export default component.exports